// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__8PmYy","detailsBorder":"styles_detailsBorder__7KLYn"};